/**
 * Pragmatic client-side check (not a full RFC parser).
 * Requires local@domain.tld with TLD at least 2 chars.
 */
export function isValidEmail(raw: string): boolean {
  const email = raw.trim()
  if (!email || email.length > 254) {
    return false
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)
}
